import _ from 'lodash'
import { getCyuQuestions } from './checkUnderstanding'

export function createSectionArray (activity) {
  if (activity.allTopics === undefined) {
    return false
  }

  const returnObj = {
    resultsArr: [],
    sectionsRead: 0,
    cyuSectionsPassed: 0,
    cyuSectionsRemaining: 0,
    totalSections: 0,
    totalTopics: 0
  }
  let ti = 0
  let si = 0
  let excti = 0
  let excsi = 0
  let readProgress
  let cyuPassed

  const progress = activity.lcrp.progress
  const useFirstAttemptTopics =
    (isRetakeCheck(activity) && activity.score.activityScore === 0 && !progress.HasTakenRetake)
  const currentTopics = useFirstAttemptTopics ? activity.finalScore.allTopics : activity.allTopics
  const includedTopics = useFirstAttemptTopics ? activity.finalScore.topics : activity.topics

  _.each(currentTopics, (topic, index) => {
    // if the topic is excluded, don't increment totalSections or totalTopics, and add it to the "excluded_sections" type
    if (activity.config.topicsExcluded.includes(index)) {
      if (activity.config.lcrpHeadings === true) {
        // add a heading for each topic
        returnObj.resultsArr.push({
          type: 'excluded_heading',
          label: topic.label
        })
      }

      /* DEV Note: Don't want the disabled sections/topics to ever match or look like enabled ones within the data;
      * appended exc and use different count to create Ids
      */
      _.each(topic.ebookSections, (section) => {
        returnObj.resultsArr.push({
          type: 'excluded_section',
          label: section.match(/^(.*?)[[]/)[1],
          ebookUrl: section.match(/\[\[([^)]+)\]\]/)[1],
          sectionId: 's' + si + '_exc',
          sectionIdInt: si,
          topicId: 't' + ti + '_exc',
          topicIdInt: ti
        })
        si++
        excsi++
      })
      excti++
      ti++
      // move to next part of the loop
      return
    }

    if (activity.config.lcrpHeadings === true) {
      // add a heading for each topic
      returnObj.resultsArr.push({
        type: 'heading',
        label: topic.label,
        topicId: 't' + ti,
        topicIdInt: ti
      })
    }

    _.each(topic.ebookSections, (section) => {
      /* the outer loop towards the beginning of this function is going through all topics, but for
       * cyuPassed, the points in the included topics array are needed.
       */
      for (let index = 0; index < includedTopics.length; index++) {
        if (includedTopics[index].topicId === topic.topicId) {
          // compute if CYU for the entire section is complete
          cyuPassed = (Math.round(100 * (includedTopics[index].totalPointsEarned /
            includedTopics[index].totalPointsAvailable))) >= 80 || false
          break
        }
        cyuPassed = false
      }

      // end CYU progress check
      readProgress = (progress && progress.fa && progress.fa[`s${si}`] && progress.fa[`s${si}`].rd) || false

      if (readProgress !== false) {
        returnObj.sectionsRead++
      }

      const result = {
        type: 'section',
        sectionId: 's' + si,
        sectionIdInt: si,
        ebookUrl: section.match(/\[\[([^)]+)\]\]/)[1],
        label: section.match(/^(.*?)[[]/)[1],
        topicId: 't' + ti,
        topicIdInt: ti,
        readingComplete: readProgress,
        cyuQuestionsRemaining: 0,
        cyuComplete: cyuPassed
      }

      if (isRetakeComplete(activity) && progress && progress.rt) {
        result.cyuQuestions = getCyuQuestions(activity, result, progress.rt[`s${si}`])
      } else if (progress && progress.fa) {
        result.cyuQuestions = getCyuQuestions(activity, result, progress.fa[`s${si}`])
      }

      // if no valid questions were found, then mark cyuComplete
      !result.cyuQuestions
        ? result.cyuComplete = true
        : result.cyuQuestionsRemaining = result.cyuQuestions.length

      result.cyuComplete ? returnObj.cyuSectionsPassed++ : returnObj.cyuSectionsRemaining++

      returnObj.resultsArr.push(result)

      si++
    })

    ti++
  })

  returnObj.totalTopics = ti - excti
  returnObj.totalSections = si - excsi

  return returnObj
}

export function getNextUnreadSectionById (activity, sectionIdInt) {
  const sectionArr = createSectionArray(activity)
  let returnVal = false

  _.each(sectionArr.resultsArr, (result) => {
    if (result.type === 'section' && result.sectionIdInt === sectionIdInt &&
      result.readingComplete === false) {
      returnVal = result
      return false
    }
  })
  return returnVal
}

export function getNextUnreadSection (activity) {
  const sectionArr = createSectionArray(activity)
  let returnVal = false

  _.each(sectionArr.resultsArr, (result) => {
    if (result.type === 'section' && result.readingComplete === false) {
      returnVal = result
      return false
    }
  })
  return returnVal
}

export function isRetakeCheck (activity) {
  // make this less stupid
  return (activity.score.activityGrade === 100 && !activity.finalScore) || !(!activity.finalScore)
}

export function isRetakeComplete (activity) {
  if (isRetakeCheck(activity)) {
    if (activity.score.activityScore >= activity.score.scoreTarget) {
      return true
    } else {
      return false
    }
  } else {
    return false
  }
}

export function isInProgressCheck (activity) {
  const { cyuSectionsRemaining } = createSectionArray(activity)
  return activity.startActivity || ((activity.score.activityScore > 0 &&
      activity.score.activityScore < activity.score.scoreTarget) ||
      (activity.score.activityScore === 0 && activity.lcrp.progress.HasTakenRetake) ||
      (cyuSectionsRemaining === 0 && (activity.score.activityScore < activity.score.scoreTarget) &&
      (activity.score.curCard && !activity.score.curCard.completed)))
}

export function populateDefaultLCRPProgress (activity) {
  const returnObj = { lcrp: { progress: { fa: {}, rt: {}, ra: [] } } }
  const sectionArr = createSectionArray(activity)

  _.each(sectionArr.resultsArr, (result) => {
    if (result.sectionId !== undefined) {
      returnObj.lcrp.progress.fa[`${result.sectionId}`] = { cyuC: [] }
      returnObj.lcrp.progress.rt[`${result.sectionId}`] = { cyuC: [] }
    }
  })

  return returnObj
}

export function resetRetake (activity) {
  const sectionArr = createSectionArray(activity)
  const cyuSectionsRemaining = sectionArr.cyuSectionsRemaining

  if (cyuSectionsRemaining === 0 && isRetakeComplete(activity)) {
    const oldRetake = { tp: [] }
    oldRetake.score = activity.score.activityScore
    oldRetake.target = activity.score.scoreTarget

    activity.score.activityScore = 0
    activity.score.activityGrade = 0
    activity.score.completedQuestionCount = 0

    for (let i = 0; i < activity.topics.length; i++) {
      oldRetake.tp[i] = {}
      oldRetake.tp[i].qr = activity.topics[i].questionsReceived
      oldRetake.tp[i].pe = activity.topics[i].totalPointsEarned
      oldRetake.tp[i].pa = activity.topics[i].totalPointsAvailable

      activity.topics[i].questionsReceived = 0
      activity.topics[i].nextLevel = 1
      activity.topics[i].totalPointsEarned = 0
      activity.topics[i].totalPointsAvailable = 0
    }

    // save the old retake
    activity.lcrp.progress.ra.push(oldRetake)

    activity.studentData.activity_questions_received = 0
    activity.studentData.rt.hintCount = 0

    if (activity.lcrp.progress) {
      _.each(sectionArr.resultsArr, (result) => {
        if (result.sectionId !== undefined) {
          activity.lcrp.progress.rt[`${result.sectionId}`] = { cyuC: [] }
        }
      })
    }
  }
}
